import { selectWeblabList } from 'src/redux/slices/weblab';
import { useRouter } from 'next/router';
import { useAppSelector } from 'src/redux/hooks';
import { Trans as ReactTrans, TransProps } from 'react-i18next';
import { DefaultNamespace, Trans as NextTrans } from 'next-i18next';
import { getIsSSRPage } from 'src/utils';
import { TFuncKey, Namespace, KeyPrefix } from 'i18next';

export default function Trans<
  K extends TFuncKey<N, TKPrefix> extends infer A ? A : never,
  N extends Namespace = DefaultNamespace,
  TKPrefix extends KeyPrefix<N> = undefined,
  E = React.HTMLProps<HTMLDivElement>,
>(props: TransProps<K, N, TKPrefix, E>): React.ReactElement {
  const { pathname } = useRouter();
  const weblabList = useAppSelector(selectWeblabList);
  const isSSRpage = getIsSSRPage(pathname, weblabList);
  if (isSSRpage) {
    return <NextTrans {...props} />;
  }
  return <ReactTrans {...props} />;
}
